var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import React from 'react';
import styled from 'styled-components';
var Img = styled.img(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  object-fit: cover;\n"], ["\n  object-fit: cover;\n"])));
export var ODImageFileRenderer = function (props) {
    var link = props.value, _a = props.width, width = _a === void 0 ? 100 : _a, _b = props.height, height = _b === void 0 ? 100 : _b, _c = props.alt, alt = _c === void 0 ? '' : _c;
    var imgProps = { width: width, height: height };
    return link ? (React.createElement(Img, __assign({ style: { width: width, height: height }, alt: alt, src: link }, imgProps))) : (React.createElement(Img, __assign({ alt: "empty", src: "data:image/gif;base64,R0lGODlhAQABAIAAAAAAAP///yH5BAEAAAAALAAAAAABAAEAAAIBRAA7", style: { width: width, height: height } }, imgProps)));
};
var templateObject_1;
//# sourceMappingURL=ODImageFileRenderer.js.map